import { render } from "./OverviewSection.vue?vue&type=template&id=94625cdc&scoped=true"
import script from "./OverviewSection.vue?vue&type=script&lang=ts"
export * from "./OverviewSection.vue?vue&type=script&lang=ts"

import "./OverviewSection.vue?vue&type=style&index=0&id=94625cdc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94625cdc"

export default script